import "./styles/styles.css";
import { Menu, Sidebar as ProSideBar } from "react-pro-sidebar";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { userSelectedHq } from "atoms/auth";
import { NavigationItems } from "./NavigationItems";
import { canChangeOfficeOrHqAtom } from "atoms/reporting";
import { initialPageLoad } from "atoms/sidebar";
import useUserInfo from "hooks/useUserInfo";
import { SidebarHeader } from "./SidebarHeader";
import { SidebarFooter } from "./SidebarFooter";
import { MobileHeader } from "./MobileHeader";
import { useQueryString } from "hooks";

export type AppMode = "Customer" | "Back Office";
export const Sidebar = () => {
  const [appMode, setAppMode] = useState<AppMode>("Customer");
  const [initialLoad, setInitialLoad] = useRecoilState(initialPageLoad);
  const { roleName } = useUserInfo();
  const { pathname } = useLocation();
  const selectedHq = useRecoilValue(userSelectedHq);
  const canChangeOfficeOrHq = useRecoilValue(canChangeOfficeOrHqAtom);

  const isSellerView = roleName === "Seller";
  const isLoadingReport = pathname === "/analytics" && !canChangeOfficeOrHq;

  const hideSidebar = [
    "login",
    "password",
    "ap-order",
    "expired-token",
    "sellers"
  ].some(p => pathname.includes(p));

  const { isCustomerBranding } = useQueryString();

  useEffect(() => {
    if (
      pathname.startsWith("/back-office") &&
      appMode !== "Back Office" &&
      initialLoad
    ) {
      setAppMode("Back Office");
      setInitialLoad(false);
    }
  }, [pathname, appMode, initialLoad, setInitialLoad]);

  if (isSellerView || isCustomerBranding || hideSidebar) {
    return null;
  }

  return (
    <>
      <MobileHeader />

      <ProSideBar breakPoint="md" width="320px" className="realforce-sidebar">
        <SidebarHeader
          setAppMode={setAppMode}
          appMode={appMode}
          selectedHq={selectedHq}
          isLoadingReport={isLoadingReport}
        />

        <Menu>
          <NavigationItems appMode={appMode} />
        </Menu>

        <SidebarFooter />
      </ProSideBar>
    </>
  );
};
